import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { DeployParams } from 'src/app/deployParams';
import { PageType, EventMappingType, ComponentName, ErrorLevel, TimeFilter } from 'src/app/models/enums';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { IOddSheets } from 'src/app/models/oddSheets/oddSheets.interface';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { IRegion } from 'src/app/models/sportHierarchy/region';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { RegionNameMap } from 'src/app/models/util/regionNameMap';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SportsService } from 'src/app/services/sports.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { environment } from 'src/environments/environment';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';

@Component({
  selector: 'app-results-sports-tree',
  templateUrl: './results-sports-tree.component.html',
  styleUrls: ['../sportstree/sportstree.component.less']
})
export class ResultsSportsTreeComponent implements OnInit, OnDestroy, OnChanges {

  sports: ISport[] = [];
  private subscription: Subscription = new Subscription();
  isMobileView: boolean;
  pageType: PageType = PageType.Results;
  pageTypeEnum = PageType;
  isLive = false;
  private language: string;
  languageForBetradar: string;
  eventMappingTypeEnum = EventMappingType;
  private dateToStringFormat: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' };
  srcSelection: ISportRegionCompetitionSelection;
  srcSelectionIds: ISrcSelectionIds;
  public showNoEventsForSportMessage = false;
  public oddSheets: IOddSheets = null;
  public downloadListUrl: string = environment.baseURL + 'downloadList';
  public viewConfigurations = ViewConfigurations;

  // myLeaguesTitle: string;
  regionNameMap = RegionNameMap;

  dynamicTranslations = DynamicTranslations;

  @Input()
  timeFilter: TimeFilter;


  constructor(
    public sportsService: SportsService,
    private utilityService: UtilityService,
    private queryParams: QueryParamsService,
    private loaderService: LoaderService,
    storage: StorageService,
    private notificationService: NotificationService) {
    this.isMobileView = utilityService.mobileView;


    this.language = storage.language;


    // this.subscription.add(sportsService.timeFilterChanged$.subscribe((x) => {
    //   this.getSportsTree();
    // }));

    this.subscription.add(this.sportsService.deselectSportsNotification$.subscribe(() => this.deselectSports()));

    if (this.isMobileView) {
      this.subscription.add(this.sportsService.srcSelectionChanged$.subscribe(() => {
        this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
        // this.srcSelection = {
        //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
        //   region: this.sportsService.sportRegionCompetitionSelection.region,
        //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
        // };
      }));
    }
  }

  ngOnInit(): void {
    this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
    // this.srcSelection = {
    //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
    //   region: this.sportsService.sportRegionCompetitionSelection.region,
    //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
    // };
    this.pageType = PageType.Results;
    if (this.utilityService.mobileView) {
      this.dateToStringFormat = { weekday: 'short', month: '2-digit', day: '2-digit' };
    }
    this.queryParams.pageTypeChanged$.subscribe(pageType => {
      this.pageType = pageType;
      // if (this.pageType === PageType.Live) {
      //   this.isLive = true;
      // } else {
      //   this.isLive = false;
      // }
    });
    // this.getSportsTree();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getSportsTree();
    if (this.isMobileView) {
      this.sportsService.clearSelectionsForSelectedSport();
    }
  }

  getSportsTree() {
    if (!this.timeFilter) {
      return;
    }
    this.loaderService.showHideLoader(true);
    this.sportsService.getSportTreeForResultPage(this.timeFilter).subscribe(sports => {
      if (sports.length === 0) {
        this.sportsService.selectSportNotify(null, this.isLive, ComponentName.ResultsSportTreeComponent);
      }
      this.sports = sports;
      if (!this.srcSelection || !this.srcSelection.sport) {
        if (this.sports.length > 0 && !this.isMobileView) {
          this.selectSport(this.sports[0]);
        }
      } else {
        const sportToSelect = this.sports.find((s) => s.id === this.srcSelection.sport.id);
        let regionToSelect: IRegion;
        let competitionToSelect: ICompetition;
        if (sportToSelect && this.srcSelection.region) {
          if (this.srcSelection.region) {
            regionToSelect = sportToSelect.regions.find((r) => r.id === this.srcSelection.region.id);
            if (regionToSelect && this.srcSelection.competition) {
              if (this.srcSelection.competition) {
                competitionToSelect = regionToSelect.competitions.find((c) => c.id === this.srcSelection.competition.id);
              }
            }
          }
        }

        if (sportToSelect) {
          sportToSelect.showRegions = this.srcSelection.sport.showRegions;
          if (regionToSelect) {
            regionToSelect.showCompetitions = this.srcSelection.region.showCompetitions;
            if (competitionToSelect) {
              this.selectCompetition(competitionToSelect, sportToSelect, regionToSelect);
            } else {
              this.selectRegion(regionToSelect, sportToSelect);
            }
          } else {
            this.selectSport(sportToSelect);
          }
        } else {
          if (this.sports.length > 0) {
            this.selectSport(this.sports[0]);
          }
        }
      }
      this.loaderService.showHideLoader(false);
    });
  }

  sendNoEventsNotification(message: string) {
    const error: ICustomNotification = {
      title: DynamicTranslations.notification_title,
      message,
      errorLevel: ErrorLevel.Notification,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(error);
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  selectSport(sport: ISport, selectToTreeBottom: boolean = true): void {
    if (sport.isSelected) {
      if (!sport.specialOfferType) {
        sport.showRegions = !sport.showRegions;
      }
      return;
    } else {
      this.deselectSports();
      sport.isSelected = true;
      if (!sport.specialOfferType) {
        sport.showRegions = true;
      }
      // scroll top
      window.parent.scroll(0, 0);
    }

    // this.queryParams.pageType = this.isLive ? PageType.Live : PageType.Prematch;

    if (selectToTreeBottom && sport.regions.length > 0) {
      this.selectRegion(sport.regions[0], sport);
    }
    if (!selectToTreeBottom) {
      this.sportsService.selectSportNotify(sport, this.isLive, ComponentName.ResultsSportTreeComponent);
    }

  }

  selectRegion(region: IRegion, sport: ISport, selectToTreeBottom: boolean = true): void {
    if (region.isSelected) {
      region.showCompetitions = !region.showCompetitions;
      return;
    } else {
      this.deselectRegions(sport);
      region.isSelected = true;
      region.showCompetitions = true;

    }

    if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
      // this.queryParams.pageType = this.isLive ? PageType.Live : PageType.Prematch;
    }

    sport.isSelected = true;

    if (selectToTreeBottom && region.competitions.length > 0 && !ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
      this.selectCompetition(region.competitions[0], sport, region);
    }

    if (!selectToTreeBottom || ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
      this.sportsService.selectRegionNotify(region, sport, this.isLive, ComponentName.ResultsSportTreeComponent);
    }

  }

  selectCompetition(competition: ICompetition, sport: ISport, region: IRegion): void {
    if (competition.isSelected) {
      competition.isExpanded = false;
      if (this.isMobileView) {
        competition.isSelected = false;
      }
      return;
    }

    this.deselectCompetitions(region);

    competition.isSelected = true;

    if (!ViewConfigurations.showCompetitionsInSportTree) {
      region.isSelected = true;
    } else {
      region.isSelected = false;
      region.showCompetitions = true;
    }

    sport.isSelected = true;
    sport.showRegions = true;

    this.sportsService.selectCompetitionNotify(competition, region, sport, this.isLive, ComponentName.ResultsSportTreeComponent);
  }

  deselectSports() {
    for (const sport of this.sports) {
      sport.isSelected = false;
      sport.showRegions = false;
      this.deselectRegions(sport);
    }
  }

  deselectRegions(sport: ISport) {
    for (const region of sport.regions) {
      region.isSelected = false;
      region.showCompetitions = false;
      if (!sport.specialOfferType) {
        this.deselectCompetitions(region);
      }
    }
  }

  deselectCompetitions(region: IRegion) {
    for (const competition of region.competitions) {
      competition.isSelected = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
